'use client'

import { useEffect, useState } from 'react'
import './ContactUs.css'
import { Helmet } from 'react-helmet'
import { Axios } from '../Axios/Axios'
import FullScreenSpinner from '../Spinner/FullScreenSpinner'
import { Notification } from '../Notification/Notification'

const axios = new Axios();

export default function Example() {
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    phoneNumber: '',
    message: '',
    type: "contact"
  });

  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    setErrors(prevState => ({
      ...prevState,
      [name]: ''
    }));
  };

  useEffect( () => {

    if (notification.message) {
      setTimeout(() => {
        setNotification({ message: '', type: '' });
      }, 5000);
    }

  }, [notification])

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = {};
  
    if (!formData.firstName) formErrors.firstName = "First name is required.";
    if (!formData.lastName) formErrors.lastName = "Last name is required.";
    if (!formData.email) formErrors.email = "Email is required.";
    if (!formData.phoneNumber) formErrors.phoneNumber = "Phone number is required.";
    if (!formData.message) formErrors.message = "Message is required.";
    
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoading(true);

    axios.post('api/home/send-mail', formData).then((response) => {
      if (response.status === 200) {
        setNotification({
          message: 'Електронската поштата е успешно испратена!',
          type: 'success',
        });
      }else{
        setNotification({
          message: 'Електронската пошта не е успешно испратена. Ве молиме пробајте подоцна.',
          type: 'error',
        });
      }
    })
    .catch((error) => {
      console.error('Error submitting form:', error);
      setNotification({
        message: 'Електронската пошта не е успешно испратена. Ве молиме пробајте подоцна.',
        type: 'error',
      });
    })
    .finally(() => {
      setFormData({
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        phoneNumber: '',
        message: '',
        type: "contact"
      })
      setLoading(false);
    });
  };

  return (
    <>
    <FullScreenSpinner display={loading} />
    <Helmet>
      <title>EES | Контактирајте не</title>
      <meta name="title" content="Контактирајте не | Ваши прашања се важни" />
      <meta name="description" content="Контактирајте не за сите ваши прашања, барања или дополнителни информации. Ние сме тука за вас!" />
      <meta name="keywords" content="контактирајте не, прашања, поддршка, информации" />
    </Helmet>
    <div className="isolate bg-white px-6 py-10 sm:pb-32 lg:px-8">
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]"
      >
        <div
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
          className="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]"
        />
      </div>

      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Контактирајте не</h2>
      </div>  

      {notification.message && <Notification message={notification.message} type={notification.type} />}

      <form onSubmit={handleSubmit} className="mx-auto mt-10 max-w-xl sm:mt-20">
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div>
            <label htmlFor="first-name" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Име
            </label>
            <div className="mt-2.5">
              <input
                id="first-name"
                name="firstName"
                type="text"
                value={formData.firstName}
                onChange={handleChange}
                autoComplete="given-name"
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.firstName && <span className="text-red-600 text-sm">{errors.firstName}</span>}
            </div>
          </div>
          <div>
            <label htmlFor="last-name" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Презиме
            </label>
            <div className="mt-2.5">
              <input
                id="last-name"
                name="lastName"
                type="text"
                value={formData.lastName}
                onChange={handleChange}
                autoComplete="family-name"
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.lastName && <span className="text-red-600 text-sm">{errors.lastName}</span>}
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="company" className="block text-sm/6 font-semibold text-gray-900">
              Фирма
            </label>
            <div className="mt-2.5">
              <input
                id="company"
                name="company"
                type="text"
                value={formData.company}
                onChange={handleChange}
                autoComplete="organization"
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="email" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Електронска Пошта
            </label>
            <div className="mt-2.5">
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                autoComplete="email"
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.email && <span className="text-red-600 text-sm">{errors.email}</span>}
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="phone-number" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Телефонски број
            </label>
            <div className="mt-2.5">
              <input
                id="phone-number"
                name="phoneNumber"
                type="text"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="+389 71 123 123"
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.phoneNumber && <span className="text-red-600 text-sm">{errors.phoneNumber}</span>}
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-sm/6 font-semibold text-gray-900">
              <span className='text-red-600' >*</span> Порака
            </label>
            <div className="mt-2.5">
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                required
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
              {errors.message && <span className="text-red-600 text-sm">{errors.message}</span>}
            </div>
          </div>
        </div>
        <div className="mt-10">
          <button
            type="submit"
            variant="gradient"
            className="block w-full rounded-md bg-gray-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          >
            Ајде да збориме
          </button>
        </div>
      </form>
    </div>
    </>
  );
}
